export default "__VITE_ASSET__DhvvHuXL__"